var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 10,
    width: 10,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.884 4.999l3.933-3.931a.626.626 0 10-.885-.885L5 4.116 1.068.183a.625.625 0 00-.884.884l3.932 3.932L.183 8.932a.625.625 0 10.884.884L5 5.884l3.932 3.932a.625.625 0 00.884-.884z",
    fill: "#d12628"
  })));
}
export default __webpack_public_path__ + "media/icons/icn_close-7048eafb.svg";
export { SvgIcnClose as ReactComponent };